import React from 'react';
import { useNavigation } from 'react-router-dom';
import PostFlowLoading from 'common/components/post-flow-loading';

const GlobalLoading = ({ children }) => {
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';

  return (
    <>
      {children}
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            background: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <PostFlowLoading tip='Redirecting...' />
        </div>
      )}
    </>
  );
};

export default GlobalLoading;
